import { formatDate } from '@artosera/shared';
import { useTranslation } from 'react-i18next';

/** Une date courte dans la langue de l'interface. */
export function useDatePilotage(): (iso: string) => string {
  const { i18n } = useTranslation();
  const langue = i18n.language === 'en' ? 'en' : 'fr';
  return (iso) => formatDate(new Date(iso), langue, 'court');
}

export const montantPilotage = (v: number, devise: string) =>
  new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: devise,
    maximumFractionDigits: 2,
  }).format(v / 100);
export function EtatPilotage({ enCours, erreur }: { enCours: boolean; erreur: unknown }) {
  const { t } = useTranslation();
  if (erreur)
    return (
      <p role="alert">{erreur instanceof Error ? erreur.message : t('commun:erreurReseau')}</p>
    );
  return enCours ? <p role="status">{t('commun:chargement')}</p> : null;
}
